/**
 * @description: 收银机设置
 * @author: hwx
 * @update: lyr
 */
<template>
    <div class="cash-register-set">
        <div class="cash-list" v-show="showList">
            <div class="red-tip">注：收银机有设置管辖区域、商品的，关联收银机的设备优先以收银机设置规则对应显示</div>
            <div class="row rowmagin">
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="listShop" data-placeholder="请选择门店"></select>
                </div>
                <button type="button" class="btn bg-orange btn-flat bigbtn" @click="initTable" style="margin-right: 10px">查询</button>
                <button type="button" class="btn bg-orange btn-flat bigbtn" @click="addCash">新增收银机</button>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="cashList"></table>
            </div>
        </div>
       <!--  <div class="cash-modify" ref="cashAlert">
            <div class="row rowpadding">
                <div class="col-md-3 ct-label">门店：</div>
                <div class="col-md-8 ct-col">
                    <select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
                </div>
            </div>
            <div class="row rowpadding">
                <div class="col-md-3 ct-label">收银机名称：</div>
                <div class="col-md-8">
                    <input type="text" class="form-control" placeholder="请输收银机名称，例如：1楼超市收银机" v-model="cash_name" />
                </div>
            </div>
        </div> -->
        <!-- 新增/修改面板 -->
        <div class="add-panel" v-show="!showList">
            <h1>{{isModify?'修改收银机':'新增收银机'}}</h1>
            <el-form v-model="add_form" label-width="120px">
                <el-form-item label="门店">
                    <el-select v-model="add_form.shop_id" placeholder="请选择门店" disabled>
                        <el-option :label="item.text" :value="item.id" :key="item.id" v-for="item in shopDatas"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收银机名称">
                    <el-input v-model="add_form.name" clearable placeholder="请输入收银机名称"></el-input>
                </el-form-item>
                <el-form-item label="管辖区域">
                    <el-row>
                        <el-radio v-model="add_form.permission_area_status" label="-1">不限制</el-radio>
                        <el-radio v-model="add_form.permission_area_status" label="1">设置管辖区域<span class="red">(设置管辖区域后，则该收银机包厢状态仅显示管辖区域包厢)</span></el-radio>
                    </el-row>
                    <div class="gray-block" v-if="add_form.permission_area_status=='1'">
                        <el-checkbox v-model="checkAllPermissionArea" @change="handleCheckAllPermissionArea">全选</el-checkbox>
                        <el-checkbox-group v-model="add_form.permission_area" @change="handleCheckedPermissionAreaChange">
                            <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item label="管辖商品">
                    <el-row>
                        <el-radio v-model="add_form.permission_goods_status" label="-1">不限制</el-radio>
                        <el-radio v-model="add_form.permission_goods_status" label="1">设置管辖商品<span class="red">(设置管辖商品，则该收银机对应场景下只显示管辖商品内容)</span></el-radio>
                    </el-row>
                    <div class="gray-block" v-if="add_form.permission_goods_status=='1'">
                        <el-checkbox v-model="checkAllPermissionScene" @change="handleCheckAllPermissionScene">适用场景<span class="red">（未勾选的场景，则该场景下不受管辖商品限制，即显示所有商品）</span></el-checkbox></el-checkbox>
                        <el-checkbox-group v-model="add_form.permission_goods_scene" @change="handleCheckedPermissionSceneChange">
                            <el-checkbox v-for="item in scene_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="gray-block" v-if="add_form.permission_goods_status=='1'">
                        <el-checkbox v-model="checkAllPermissionType" @change="handleCheckAllPermissionType">管辖商品类型</el-checkbox>
                        <el-checkbox-group v-model="add_form.permission_goods_type" @change="handleCheckedPermissionTypeChange">
                            <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showList=true">返回</el-button>
                    <el-button type="primary" @click="submitSet">确认</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'cash-register-set',
        data() {
            return {
                shopDatas: [],
                showList: true,
                isModify: false,
                add_form: {
                    id: '',
                    shop_id: '',
                    name: '',
                    permission_area_status: '-1',//管辖区域 -1不限 1限制
                    permission_area: [],//管辖区域
                    permission_goods_status: '-1',//管辖商品 -1不限 1限制
                    permission_goods_type: [],//管辖商品类型
                    permission_goods_scene: [], // 商品管辖场景
                },
                room_area_list: [], //包厢区域
                checkAllPermissionArea: false,
                scene_list: [], // 管辖商品适用场景
                checkAllPermissionScene: false,
                goods_type_list: [], // 管辖商品类型
                checkAllPermissionType: false,
                // cash_name: '',
                // cash_id: '',
            }
        },
        watch: {
            
        },
        mounted: function() {
            this.$nextTick(function() {
                this.getStoreList();
                this.getGoodsScene() // 管辖商品适用场景
                this.getGoodsType() // 管辖商品类型
            });
        },
        methods: {
            // 门店数据
            getStoreList: function() {
                let _this = this;

                let shopDatas = [];
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({ id: v.id, text: v.name });
                            });
                            _this.shopDatas.shift();

                            $(_this.$refs.shop).select2({
                                data: _this.shopDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });

                            $(_this.$refs.listShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.getRoomArea(e.params.data.id)
                            });
                            $(_this.$refs.listShop).val(data.response.result[1].id).trigger('change');
                            _this.initTable();
                             _this.getRoomArea(data.response.result[1].id)
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this ) ;
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 初始化收银机设置列表
            initTable: function() {
                let _this = this;
                $(_this.$refs.cashList).bootstrapTable('destroy');
                $(_this.$refs.cashList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "name",
                        title: "收银机名称",
                        width: "20%"
                    }, {
                        field: "permission_area_str",
                        title: "管辖区域",
                        width: "20%"
                    }, {
                        field: "permission_goods_type_str",
                        title: "管辖商品",
                        width: "20%"
                    }, {
                        field: "permission_goods_scene_str",
                        title: "管辖商品适用场景",
                        width: "20%"
                    }, {
                        title: "操作",
                        width: "20%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.isModify = true;
                                _this.openModify(row)
                                // $(_this.$refs.shop).val(row.shop_id).trigger('change');
                                // _this.cash_name = row.name;
                                // _this.cash_id = row.id;
                                // _this.openModify('修改收银机');
                            },
                            'click .del': function(e, value, row) {
                                layer.confirm('删除后不可恢复，确定删除？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.delCash(row.id, row.shop_id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue del">删除</span>'
                        }
                    }]
                });
            },
            // 收银机设置列表
            getList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": $(_this.$refs.listShop).val(),
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getShopCheckstandList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 新增收银机
            addCash: function() {
                this.showList = false
                this.isModify = false
                this.add_form = {
                    id: '',
                    shop_id: $(this.$refs.listShop).val(),
                    name: '',
                    permission_area_status: '-1',
                    permission_area: [],
                    permission_goods_status: '-1',
                    permission_goods_type: [],
                    permission_goods_scene: []
                }
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取管辖商品适用场景
            getGoodsScene: function() {
                const _this = this;
                Vue.axios.post('PublicData/api_getCheckstandGoodsScene', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.scene_list = res.data.response.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取管辖商品类型
            getGoodsType: function() {
                const _this = this;
                Vue.axios.post('PublicData/api_getAllGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "show_room_pack": -1
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 管辖区域全选
            handleCheckAllPermissionArea(val) {
                this.add_form.permission_area = []
                this.checkAllPermissionArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.add_form.permission_area.push(item.id)
                    })
                }
            },

            // 选择管辖区域
            handleCheckedPermissionAreaChange(val) {
                this.checkAllPermissionArea = val.length === this.room_area_list.length
            },

            // 适用场景全选
            handleCheckAllPermissionScene(val) {
                this.add_form.permission_goods_scene = []
                this.checkAllPermissionScene = val
                if (val) {
                    this.scene_list.forEach(item => {
                        this.add_form.permission_goods_scene.push(item.id)
                    })
                }
            },

            // 选择适用场景
            handleCheckedPermissionSceneChange(val) {
                this.checkAllPermissionScene = val.length === this.scene_list.length
            },

            // 管辖商品类型全选
            handleCheckAllPermissionType(val) {
                this.add_form.permission_goods_type = []
                this.checkAllPermissionType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.add_form.permission_goods_type.push(item.id)
                    })
                }
            },

            // 选择管辖商品类型
            handleCheckedPermissionTypeChange(val) {
                this.checkAllPermissionType = val.length === this.goods_type_list.length
            },

            // 收银机设置
            submitSet: function(tit) {
                let _this = this;

                Vue.axios.post('Setting/updateShopCheckstand', {
                    "header": Vue.request_header,
                    "request": {
                        "param": _this.add_form
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if (_this.isModify) {
                            layer.msg("修改成功！")
                        }else {
                            layer.msg("新增成功！")
                        }
                        _this.showList = true
                        _this.initTable();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 修改收银机
            openModify(row) {
                this.add_form = {
                    id: row.id,
                    shop_id: row.shop_id,
                    name: row.name,
                    permission_area_status: row.permission_area_status,
                    permission_area: row.permission_area,
                    permission_goods_status: row.permission_goods_status,
                    permission_goods_type: row.permission_goods_type,
                    permission_goods_scene: row.permission_goods_scene
                }
                this.checkAllPermissionArea = row.permission_area.length == this.room_area_list.length
                this.checkAllPermissionScene = row.permission_goods_scene.length == this.scene_list.length
                this.checkAllPermissionType = row.permission_goods_type.length == this.goods_type_list.length
                this.showList = false
            },
            // 删除收银机
            delCash: function(id, shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delshopCheckstand",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('删除成功');
                            _this.initTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .cash-register-set {
        .red-tip {
            color: red;
            margin-bottom: 10px;
        }
        .add-panel {
            .el-input,
            .el-select {
                width: 400px;
            }
            .red {
                color: red;
            }
            .gray-block {
                width: 900px;
                margin: 10px 0;
                padding: 10px;
                background: #efefef;
                .el-checkbox {
                    width: 150px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>